import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getInstances, disableInstance, enableInstance, setInstanceEnvironment } from '../../services/api';

const ENVIRONMENTS = ['INTEGRATION', 'VALIDATION', 'PREPROD', 'PROD', 'TEST'];

export default function InstancesPage() {
  const [instances, setInstances] = useState([]);
  const [filter, setFilter] = useState('all'); // all | active | disabled
  const [disableModal, setDisableModal] = useState(null);
  const [reason, setReason] = useState('');
  const navigate = useNavigate();

  const load = () => getInstances().then(setInstances);
  useEffect(() => { load(); }, []);

  const filtered = instances.filter(i => {
    if (filter === 'active') return i.active;
    if (filter === 'disabled') return !i.active;
    return true;
  });

  const handleDisable = async () => {
    await disableInstance(disableModal, reason);
    setDisableModal(null);
    setReason('');
    load();
  };

  const handleEnable = async id => { await enableInstance(id); load(); };

  const handleEnvironment = async (id, environment) => {
    await setInstanceEnvironment(id, environment);
    load();
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <h1 style={{ margin: 0 }}>Instances serveur</h1>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          {['all', 'active', 'disabled'].map(f => (
            <button key={f} onClick={() => setFilter(f)}
              style={{ ...filterBtn, ...(filter === f ? { background: '#232853', color: '#fff', borderColor: '#232853' } : {}) }}>
              {f === 'all' ? 'Toutes' : f === 'active' ? 'Actives' : 'Désactivées'}
            </button>
          ))}
        </div>
      </div>

      <div style={{ background: '#ffffff', borderRadius: '12px', overflowX: 'auto' }}>
        <table style={{ width: '100%', minWidth: '980px', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ color: '#8a8f99', fontSize: '0.8rem', textTransform: 'uppercase', borderBottom: '1px solid #cdcdcd' }}>
              {['Client', 'Serveur', 'IP', 'Environnement', 'Derniers users', 'Dernière activité', 'Statut', 'Actions'].map(h =>
                <th key={h} style={{ padding: '0.75rem 1rem', textAlign: 'left' }}>{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {filtered.map(inst => (
              <tr key={inst.id} style={{ borderBottom: '1px solid #ececec' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#f5f5f5'}
                  onMouseLeave={e => e.currentTarget.style.background = ''}>
                <td style={td}>
                  <button onClick={() => navigate(`/licenses/${inst.licenseId}`)} style={linkText}>
                    {inst.clientName}
                  </button>
                </td>
                <td style={td}>{inst.serverName}</td>
                <td style={{ ...td, fontFamily: 'monospace', color: '#6b7280', fontSize: '0.85rem' }}>{inst.serverIp}</td>
                <td style={td}>
                  <select value={inst.environment || ''}
                          onChange={e => handleEnvironment(inst.id, e.target.value)}
                          style={{ background: '#f5f5f5', border: '1px solid #cdcdcd', color: inst.environment ? '#555555' : '#8a8f99', borderRadius: '6px', padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}>
                    <option value="">non déclaré</option>
                    {ENVIRONMENTS.map(env => <option key={env} value={env}>{env}</option>)}
                  </select>
                </td>
                <td style={{ ...td, fontWeight: 600 }}>{inst.lastReportedUsers ?? '—'}</td>
                <td style={{ ...td, color: '#6b7280', fontSize: '0.82rem' }}>
                  {inst.lastSeenAt ? new Date(inst.lastSeenAt).toLocaleString('fr-FR') : 'Jamais'}
                </td>
                <td style={td}>
                  {inst.active
                    ? <span style={badge('#e2f3e8', '#1a7f37')}>Active</span>
                    : <span title={inst.disableReason} style={badge('#fdecea', '#c62828')}>Désactivée ⓘ</span>}
                </td>
                <td style={td}>
                  {inst.active
                    ? <button onClick={() => setDisableModal(inst.id)} style={dangerBtn}>Désactiver</button>
                    : <button onClick={() => handleEnable(inst.id)} style={okBtn}>Réactiver</button>}
                </td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr><td colSpan={8} style={{ ...td, textAlign: 'center', color: '#8a8f99', padding: '3rem' }}>Aucune instance</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {disableModal && (
        <div style={overlay}>
          <div style={modal}>
            <h3 style={{ margin: '0 0 1rem', color: '#444444' }}>Désactiver l'instance</h3>
            <textarea
              style={{ width: '100%', height: '80px', background: '#f5f5f5', border: '1px solid #cdcdcd', color: '#444444', padding: '0.6rem', borderRadius: '6px', resize: 'vertical', boxSizing: 'border-box' }}
              placeholder="Motif de désactivation (dépassement de licence, etc.)..."
              value={reason}
              onChange={e => setReason(e.target.value)}
            />
            <div style={{ display: 'flex', gap: '0.75rem', marginTop: '1rem', justifyContent: 'flex-end' }}>
              <button onClick={() => setDisableModal(null)} style={cancelBtn}>Annuler</button>
              <button onClick={handleDisable} style={dangerBtn}>Confirmer la désactivation</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const td = { padding: '0.85rem 1rem', color: '#444444' };
const badge = (bg, color) => ({ background: bg, color, padding: '2px 10px', borderRadius: '99px', fontSize: '0.78rem', fontWeight: 600 });
const filterBtn = { padding: '0.4rem 0.9rem', background: 'transparent', border: '1px solid #cdcdcd', color: '#6b7280', borderRadius: '6px', cursor: 'pointer', fontSize: '0.85rem' };
const linkText = { background: 'none', border: 'none', color: '#005cc5', cursor: 'pointer', padding: 0, fontSize: 'inherit' };
const dangerBtn = { padding: '0.35rem 0.85rem', background: '#fdecea', border: '1px solid #f3b8b4', color: '#b3261e', borderRadius: '6px', cursor: 'pointer', fontSize: '0.82rem' };
const okBtn = { padding: '0.35rem 0.85rem', background: '#e2f3e8', border: '1px solid #a7d7b4', color: '#1a7f37', borderRadius: '6px', cursor: 'pointer', fontSize: '0.82rem' };
const cancelBtn = { padding: '0.35rem 0.85rem', background: 'transparent', border: '1px solid #cdcdcd', color: '#6b7280', borderRadius: '6px', cursor: 'pointer' };
const overlay = { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50 };
const modal = { background: '#ffffff', borderRadius: '12px', padding: '2rem', width: '420px', boxShadow: '0 20px 60px rgba(0,0,0,0.15)' };
